import React, {useContext} from "react";
import * as PropTypes from "prop-types";
import { buyNowContext } from "../BuyNow";
import {formattedNextChargeDate} from "../../utils/orderHelper";
import {PRODUCT_CATEGORIES} from "../../../../constants";

/**
 * Return a string representing the recurring plan price.
 */
const RecurringPlanPrice = ({ hideDecimalIfWhole }) => {
  const { lineItems, plansConfiguration } = useContext(buyNowContext);

  const planLineItem = lineItems.find(li => li.product.category === PRODUCT_CATEGORIES.MEMBERSHIP);
  const selectedPlan = planLineItem ? planLineItem.product : null;

  if (!selectedPlan)
    return "";

  let result;

  if (selectedPlan.monthsDelayed)
    result = plansConfiguration.delayedMonthlyPrice;
  else
    result = selectedPlan.price;

  // Factor in the quantity.
  result *= planLineItem.quantity;

  if (hideDecimalIfWhole && result % 1 === 0)
    result = String(result);
  else
    result = result.toFixed(2);

  return result;
};

RecurringPlanPrice.propTypes = {
  hideDecimalIfWhole: PropTypes.bool
};

RecurringPlanPrice.defaultProps = {
  hideDecimalIfWhole: false
};

export default RecurringPlanPrice;